// Adapted from https://github.com/hungtcs/classed-elements/blob/master/packages/react/lib/classed.tsx
// Specifically, the tailwind-merge support was added to make it easier to work with those classes.
import type { ComponentProps, ComponentType, ElementType } from "preact/compat";
import { twMerge } from "tailwind-merge";
import { domElements, type SupportedHTMLElements } from "./util";

export type ClassedElement<C extends ElementType> = (
  classes: TemplateStringsArray,
) => ComponentType<ComponentProps<C> & { className?: string }>;

function baseClassed<C extends ElementType>(component: C): ClassedElement<C> {
  return (classes: TemplateStringsArray) => {
    return (props) => {
      const Component = component as ComponentType<
        ComponentProps<C> & { className: string }
      >;
      return (
        <Component {...props} className={twMerge(classes, props.className)} />
      );
    };
  };
}

const classed = baseClassed as typeof baseClassed & {
  [E in SupportedHTMLElements]: ClassedElement<SupportedHTMLElements>;
};

for (const element of domElements) {
  classed[element as SupportedHTMLElements] = classed(element);
}

export { classed, twMerge as classes };
